import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared.module/shared.module';


import { BenutzerAnlegenComponent } from './components/benutzer-anlegen/benutzer-anlegen.component';
import { BuergschaftCreateComponentAbschl2 } from './components/bgsch-create/bgsch-create-abschl-2.component';
import BuergschaftCreateComponent from './components/bgsch-create/bgsch-create.component';
import { JahresabschlussComponent } from './components/jahresabschluss/jahresabschluss.component';
import { KundenMaklerMandatComponent } from './components/kd-maklermandat/kd-maklermandat.component';
import { ObligoComponent } from './components/obligo/obligo.component';
import { BuergschaftenListComponent } from './components/bgsch-list/bgsch-list.component';
import { BuergschaftCreateComponentAbschl4 } from './components/bgsch-create/bgsch-create-abschl-4.component';
import { BuergschaftCreateComponentAbschl3 } from './components/bgsch-create/bgsch-create-abschl-3.component';
import { BuergschaftCreateComponentAbschl1 } from './components/bgsch-create/bgsch-create-abschl-1.component';
import { VertragAendernComponent } from './components/vertrag-aendern/vertrag-aendern.component';

import { MenuComponent } from '../layout/menu.component';
import { HeaderComponent } from '../layout/header.component';
import { FooterComponent } from '../layout/footer.component';
import { PrintBuergscheinAntrag } from './print/bgsch-antrag.component';
import { PrintKreditlinieAntrag } from './print/kreditlinie-antrag.component';
import { ServiceModule } from '../../services.module/services.module';
import { ElementsModule } from '../../elements.component.module/elements.module';
import { PipeModule } from '../../pipes.module/pipes.module';
import { ModelModule } from '../../model.module/model.module';
import { FormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        BenutzerAnlegenComponent,
        BuergschaftCreateComponentAbschl1,
        BuergschaftCreateComponentAbschl2,
        BuergschaftCreateComponentAbschl3,
        BuergschaftCreateComponentAbschl4,
        BuergschaftCreateComponent,
        BuergschaftenListComponent,
        JahresabschlussComponent,
        KundenMaklerMandatComponent,
        ObligoComponent,
        VertragAendernComponent,
        // Print
        PrintBuergscheinAntrag,
        PrintKreditlinieAntrag,
        // -- Remove later
        HeaderComponent,
        FooterComponent,
        MenuComponent
        // -- Remove till here
    ],
    imports: [
        CommonModule,
        FormsModule,
        ServiceModule,
        ElementsModule,
        PipeModule,
        ModelModule,
        SharedModule,
    ],
    exports: [
        BenutzerAnlegenComponent,
        BuergschaftCreateComponentAbschl1,
        BuergschaftCreateComponentAbschl2,
        BuergschaftCreateComponentAbschl3,
        BuergschaftCreateComponentAbschl4,
        BuergschaftCreateComponent,
        BuergschaftenListComponent,
        JahresabschlussComponent,
        KundenMaklerMandatComponent,
        ObligoComponent,
        VertragAendernComponent,
        // Print
        PrintBuergscheinAntrag,
        PrintKreditlinieAntrag,
        // Angular
        CommonModule,
        FormsModule,
        ServiceModule,
        ElementsModule,
        PipeModule,
        ModelModule,
        SharedModule,
        // -- Remove later
        HeaderComponent,
        FooterComponent,
        MenuComponent
        // -- Remove till here
    ]
})
export class InsightSharedModule {
}
